








































































































import {Component, Vue} from "vue-property-decorator";

@Component
export default class DashboardMenu extends Vue {

  get singleOrderPageClass() {
    if (this.isSingleOrderPage) {
      return 'router-link-active';
    }
    return '';
  }

  get isSingleOrderPage() {
    return this.$route.name === 'customer-order-single';
  }
}
